var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAutopay = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 157,
    viewBox: "0 0 191 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.965 100.244L173.118 118.434L152.937 138.593L134.727 129.449C134.727 129.449 134.723 129.452 134.72 129.452C128.955 132.758 122.729 135.36 116.17 137.136L109.77 156.45H81.227L74.83 137.136C68.2614 135.36 62.0391 132.758 56.2704 129.452H56.2673L38.0633 138.593L17.8791 118.434L27.0317 100.25C23.7183 94.4917 21.116 88.2741 19.3382 81.7137L0 75.3248V61.0713H41.34C41.34 90.9436 65.5885 115.162 95.4954 115.162H95.4985C125.411 115.159 149.657 90.9436 149.657 61.0713H191V75.3248L171.656 81.7168C169.878 88.2711 167.276 94.4886 163.965 100.244Z",
    fill: "#FFB257"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M156.693 61.0713C156.693 94.8001 129.35 122.143 95.6217 122.143C61.8929 122.143 34.5503 94.8001 34.5503 61.0713C34.5503 27.3426 61.8929 0 95.6217 0C129.35 0 156.693 27.3426 156.693 61.0713Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4423 18.0054L62.5312 28.0849C54.072 36.5367 48.8308 48.2059 48.8308 61.0716H34.5503C34.5503 44.2713 41.3936 29.0366 52.4423 18.0054V18.0054Z",
    fill: "#FFD31F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M156.45 61.0716H142.169C142.169 48.2059 136.928 36.5367 128.469 28.0849L138.561 18.0054C149.61 29.04 156.45 44.2713 156.45 61.0716Z",
    fill: "#FFD31F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3727 37.957L82.4828 48.0548C79.1416 51.3919 77.0767 55.9969 77.0767 61.0717H62.7745C62.7745 52.0552 66.4478 43.8782 72.3762 37.957H72.3727Z",
    fill: "#FFD31F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M128.222 61.0717H113.922C113.922 55.9969 111.854 51.3919 108.517 48.0548L118.626 37.957C124.553 43.8782 128.225 52.0587 128.225 61.0717H128.222Z",
    fill: "#FFD31F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M138.688 17.9067L128.58 28.0092L95.5 61.0713L82.4665 48.0483L72.3585 37.9458L62.4166 28.0092L52.3121 17.9067C63.3779 6.84676 78.6522 0 95.5 0C112.348 0 127.622 6.85022 138.688 17.9067V17.9067Z",
    fill: "#FFEFB2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M138.688 17.8886L128.58 27.9809C120.104 19.5183 108.402 14.277 95.5 14.277C82.5979 14.277 70.8923 19.5183 62.4166 27.9809L52.3121 17.8886C63.3779 6.83985 78.6522 0 95.5 0C112.348 0 127.622 6.8433 138.688 17.8886V17.8886Z",
    fill: "#0577FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M118.736 37.8241L108.639 47.9324C105.306 44.5918 100.701 42.5238 95.6234 42.5238C90.5455 42.5238 85.9374 44.5952 82.604 47.9324L72.507 37.8241C78.4312 31.8933 86.6076 28.2241 95.6234 28.2241C104.639 28.2241 112.816 31.8933 118.736 37.8241Z",
    fill: "#0577FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5017 61.0713L77.1299 79.3197H95.5017H113.87L95.5017 61.0713Z",
    fill: "#091F83"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M104.867 79.3198H86.1324V96.8383H104.867V79.3198Z",
    fill: "#0577FF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAutopay);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Autopay.6c04b062f4c34888a7c6420662dc0797.svg";